"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var ChevronRight_1 = __importDefault(require("@nerdwallet/react-icon/material/ChevronRight"));
var Close_1 = __importDefault(require("@nerdwallet/react-icon/material/Close"));
var currency_1 = require("@nerdwallet/currency");
var variables_1 = require("../../../styles/variables");
var drawer_context_1 = require("../drawer-context");
var nerdwallet_plus_drawer_module_css_1 = __importDefault(require("../nerdwallet-plus-drawer.module.css"));
var GREEN_DARK = variables_1.colors["green-dark"];
function CloseButton() {
    var close = (0, drawer_context_1.useDrawerContext)().close;
    return (react_1.default.createElement(currency_1.Box, { className: nerdwallet_plus_drawer_module_css_1.default.textAlignEnd },
        react_1.default.createElement(Close_1.default, { className: (0, classnames_1.default)(nerdwallet_plus_drawer_module_css_1.default.hoverCursor, nerdwallet_plus_drawer_module_css_1.default.hideDesktop), onClick: close, size: 30 }),
        react_1.default.createElement(ChevronRight_1.default, { className: (0, classnames_1.default)(nerdwallet_plus_drawer_module_css_1.default.rotate180, nerdwallet_plus_drawer_module_css_1.default.hideMobile, nerdwallet_plus_drawer_module_css_1.default.hoverCursor), color: GREEN_DARK, onClick: close, size: 30 })));
}
exports.default = CloseButton;
